export const ForceAppScrollTopToZero = () => {
    const appElementAKAScollingDiv = document.querySelector('#app');
    if (appElementAKAScollingDiv) {
        appElementAKAScollingDiv.scrollTop = 0;
    }
};

export default ForceAppScrollTopToZero;
